/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Formik } from 'formik';
import { FC, useRef, useState } from 'react';
import * as yup from 'yup';
import { useFormContext } from '../../../../../contexts/FormContext';
import {
  AudienceChangerInput,
  FormType,
  PersonaMarketingIdeasInput,
} from '../../../../../types/FormTypes';
import { ListenToFormikValues } from '../../../../shared/formik/ListenToFormikValues';
import { GenerateResponseButtons } from '../GenerateResponseButtons';
import formStyles from '../formStyles.module.css';
import { usePersonaContext } from '../../../../../contexts/PersonaContext';
import React from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image';
import styled from '@emotion/styled';
import { useEffect } from 'react';
import styles from './changerStyle.module.css';
import { AudiencePersonaSoloPopup } from '../../../personasPage/AudiencePersonaPopup';
import { BasicPopup2 } from '../../../../shared/popups/BasicPopup';
import { BasicButton } from '../../../../shared/buttons/BasicButton';
import { EditAudiencePersonaPopup } from '../../../personasPage/EditAudiencePersonaPopup';
import { BoxedAutoResizeTextarea } from '../../../../shared/inputs/BoxedAutoResizeTextarea';
import axios from 'axios';
import { useAuthContext } from '../../../../../contexts/AuthContext';
import { AudiencePersona, ProductPersona } from '../../../../../types/Persona.type';

const DropDownContainer3 = styled('div')`
  width: 100%;
  cursor: pointer;
  position: relative;
  display: flex;
  z-index: 2;
  flex-direction: column;
  padding: 0em 0.3em 0em 0em;
`;

const DropDownIcon3 = styled('div')`
  position: sticky;
  left: 100%;
  display: flex;
  z-index: 2;
  flex-direction: column;
`;

const DropDownHeader = styled('div')`
  width: 100%;
  cursor: pointer;
  margin-bottom: 0.4em;
  padding: 0.5em 0.5em 0.5em 0.5em;
  font-weight: 400;
  font-size: 1rem;
  color: black;
  font-family: "Poppins", sans-serif;
  background: white;
  border: 1px solid black;
  border-radius: 4px;
  display: flex;
`;

const DropDownListContainer = styled('div')`
  width: 100%;
  cursor: pointer;
  font-weight: 500;
  font-size: 1.3rem;
  font-family: "Poppins", sans-serif;
  color: #3faffa;
  background: white;
  border: 1.83px solid black;
  border-radius: 2px;
  width: 100%;
  z-index: 0;
  max-height: 41vh;
`;

const DropDownList = styled('ul')`
  width: 100%;
  cursor: pointer;
  padding: 0;
  margin: 0;
  z-index: 0;
  background: #ffffff;
  box-sizing: border-box;
  border-radius: 2px;
  color: black;
  font-size: 0.9rem;
  font-weight: 500;
  font-family: "Poppins", sans-serif;
  max-height: 40vh;
  overflow: scroll;
  overflow-x: hidden;
  &:first-of-type {
    padding-top: 0em;
  }
`;

const ListItem = styled('li')`
  width: 100%;
  cursor: pointer;
  list-style: none;
  padding-bottom: 0.6em;
  padding-top: 0.6em;
  padding-left: 1em;
  border-bottom: 1px solid black;
  font-family: "Poppins", sans-serif;
  display: flex;
  z-index: 500;

  justify-content: space-between;
  align-items: center;
  &: last-of-type {
    border-bottom: 0px;
  }

  &:hover {
    color: #4690ff;
    background-color: #dadada;
  }
`;

const ListItem2 = styled('li')`
  width: 100%;
  cursor: pointer;
  list-style: none;
  padding-bottom: 0.8em;
  padding-top: 0.8em;
  padding-left: 1em;
  border-bottom: 1px solid black;
  color: gray;
  display: flex;
  font-family: "Poppins", sans-serif;
  align-items: center;

  &:hover {
    color: #4690ff;
    background-color: #dadada;
  }
`;

const Innertext = styled('div')`
  padding-top: 0.4em;
  padding-left: 0.5em;
`;

const Innertext2 = styled('div')`
  padding-top: 0.5em;
  padding-left: 0.5em;
  padding-bottom: 0.5em;
`;

interface ChildComponentProps {
  onButtonClick: (
    v1: string,
    id: string,
    v3: string,
    v4: string[],
    v5: string,
    v6: string,
    v7: string,
    v8: string,
    v9: string[],
    v10: { replaceThis: string; withThis: string }[],
    v11: string[],
    p1: string,
    p2: string,
    p3: string,
    p4: { value: string; label: string },
    a1: string,
    a2: { value: string; label: string },
    a3: string[],
    a4: string[],
    a5: string[],
    a6: string[],
    a7: string,
    a8: string,
    a9: string,
    a10: string,
    a11: string,
    a12: string,
    neededMenu: string
  ) => void;
}

const PersonaMarketingIdeasInputsSchema = yup.object<
  Partial<Record<keyof AudienceChangerInput, yup.AnySchema>>
>({
  text: yup.string().required('Please enter the text to convert.'),

  //   companyWebsite: yup.string().notRequired(),
  //   intent: yup.string().required('Please select the goal of your marketing campaign.'),
  // topic: yup.string().required('Please add the brainstorming topic'),
  //   brandDescription: yup.string().required(),
  //     industry: yup.string().required(),
  //     painpoint: yup.string().required(),
  //     location: yup.string().required(),
  //     occupation: yup.string().required(),
  //   age: yup.string().required(),
});

export const AudienceChangerForm: FC<ChildComponentProps> = ({
  onButtonClick,
}) => {
  const {
    audienceChangerInput,
    setAudienceChangerInput,
    setCanKeepGoing,
    loading,
    submitToolkitForm,
  } = useFormContext();
  const { audiencePersonas, currentAudPersona, saveCurrentPersonas } = usePersonaContext();
  const { deleteAudience } = usePersonaContext();
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const { userData, logRecentPersonaData } = useAuthContext();
  const [selectedAudOption, setSelectedAudOption] = useState(
    currentAudPersona?.audience ?? 'Please Select an Audience'
  );
  const [selectedAudience, setAudienceList] = useState('');
  const menuRef = useRef<HTMLDivElement>(null);
  const menuRef2 = useRef<HTMLDivElement>(null);
  const menuRef3 = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handler = (e: { target: any }) => {
      if (!menuRef3.current?.contains(e.target)) {
        setIsOpen3(false);
      }
      if (!menuRef2.current?.contains(e.target)) {
        setIsOpen2(false);
      }
      if (!menuRef.current?.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => {
      document.removeEventListener('mousedown', handler);
    };
  });
  const toggling2 = () => setIsOpen2(!isOpen2);
  const [showAudiencePopup, setShowAudiencePopup] = useState(false);
  const [showAudEditPopup, setAudEditPopup] = useState(false);
  const [showAudDeletePopup, setAudDeletePopup] = useState(false);

  const [A0, setA0] = useState(currentAudPersona?.audience ?? ''); //audience
  const [A1, setA1] = useState(currentAudPersona?.painpoints ?? ''); //painpoint
  const [A2, setA2] = useState(currentAudPersona?.location ?? ['']); //location
  const [A3, setA3] = useState(currentAudPersona?.occupation ?? ['']); //occupation
  const [A4, setA4] = useState(currentAudPersona?.age ?? ['']); //age
  const [A5, setA5] = useState(currentAudPersona?.goals ?? ''); //goals
  const [A6, setA6] = useState(currentAudPersona?.barriers ?? ''); //barriers
  const [A7, setA7] = useState(currentAudPersona?.triggers ?? ''); //triggers
  const [A8, setA8] = useState(currentAudPersona?.profilePic ?? ''); //ProfilePic
  const [picture2, setPicture2] = useState(currentAudPersona?.profilePic ?? '');

  const [v1, setv1] = useState('');
  const [id, setv2] = useState('');
  const [v3, setv3] = useState('');
  const [v4, setv4] = useState(['']);
  const [v5, setv5] = useState('');
  const [v6, setv6] = useState('');
  const [v7, setv7] = useState('');
  const [v8, setv8] = useState('');
  const [v9, setv9] = useState(['']);
  const [v10, setv10] = useState([{ replaceThis: '', withThis: '' }]);
  const [v11, setv11] = useState(['']);
  const [p1, setp1] = useState('');
  const [p2, setp2] = useState('');
  const [p3, setp3] = useState('');
  const [p4, setp4] = useState({ value: '', label: '' });
  const [a1, seta1] = useState('');
  const [a2, seta2] = useState({ value: '', label: '' });
  const [a3, seta3] = useState(['']);
  const [a4, seta4] = useState(['']);
  const [a5, seta5] = useState(['']);
  const [a6, seta6] = useState(['']);
  const [a7, seta7] = useState('');
  const [a8, seta8] = useState('');
  const [a9, seta9] = useState('');
  const [a10, seta10] = useState('');
  const [a11, seta11] = useState('');
  const [a12, seta12] = useState('');

  const [audError, setAudError] = useState(false);

  const [buttonClicked, setButtonClicked] = useState(false);
  const [neededMenu, setNeededMenu] = useState('');

  useEffect(() => {
    if (buttonClicked) {
      sendData();
      setButtonClicked(false);
    }
  }, [buttonClicked]);

  const onAudOptionClicked =
    (
      value: React.SetStateAction<string>,
      value2: React.SetStateAction<string>,
      value3: React.SetStateAction<string[]>,
      value4: React.SetStateAction<string[]>,
      value5: React.SetStateAction<string[]>,
      value6: React.SetStateAction<string>,
      value7: React.SetStateAction<string>,
      value8: React.SetStateAction<string>,
      v9: React.SetStateAction<string>,
      entireAud: React.SetStateAction<AudiencePersona>
    ) =>
    () => {
      setSelectedAudOption(value);
      setA0(value);
      setA1(value2);
      setA2(value3);
      setA3(value4);
      setA4(value5);
      setA5(value6);
      setA6(value7);
      setA7(value8);
      setA8(v9);
      saveCurrentPersonas(
                {} as ProductPersona,
                entireAud as AudiencePersona,
              );
      setPicture2(v9);
      setAudError(false);
      setIsOpen2(false);
    };

  const AudienceCreateClick = () => {
    setNeededMenu('AudienceCreate');
    setButtonClicked(true);
  };

  const AudienceEditClick =
    (
      a1: React.SetStateAction<string>,
      a2: React.SetStateAction<{ value: string; label: string }>,
      a3: React.SetStateAction<string[]>,
      a4: React.SetStateAction<string[]>,
      a5: React.SetStateAction<string[]>,
      a6: React.SetStateAction<string[]>,
      a7: React.SetStateAction<string>,
      a8: React.SetStateAction<string>,
      a9: React.SetStateAction<string>,
      a10: React.SetStateAction<string>,
      a11: React.SetStateAction<string>,
      a12: React.SetStateAction<string>
    ) =>
    () => {
      seta1(a1); //audience
      seta2(a2); // brand
      seta3(a3); //gender
      seta4(a4); //age
      seta5(a5); //occupation
      seta6(a6); //location
      seta7(a7); //painpoint
      seta8(a8); //id
      seta9(a9); //goals
      seta10(a10); //barriers
      seta11(a11); //triggers
      seta12(a12); //pp
      setNeededMenu('AudienceEdit');
      setButtonClicked(true);
    };

  const AudienceDeleteClick =
    (
      a1: React.SetStateAction<string>,
      a2: React.SetStateAction<{ value: string; label: string }>,
      a3: React.SetStateAction<string[]>,
      a4: React.SetStateAction<string[]>,
      a5: React.SetStateAction<string[]>,
      a6: React.SetStateAction<string[]>,
      a7: React.SetStateAction<string>,
      a8: React.SetStateAction<string>,
      a9: React.SetStateAction<string>,
      a10: React.SetStateAction<string>,
      a11: React.SetStateAction<string>,
      a12: React.SetStateAction<string>
    ) =>
    () => {
      seta1(a1); //audience
      seta2(a2); // brand
      seta3(a3); //gender
      seta4(a4); //age
      seta5(a5); //occupation
      seta6(a6); //location
      seta7(a7); //painpoint
      seta8(a8); //id
      seta9(a9); //goals
      seta10(a10); //barriers
      seta11(a11); //triggers
      seta12(a12); //pp
      setNeededMenu('AudienceDelete');
      setButtonClicked(true);
    };

  const sendData = () => {
    // Sends the data to the parent component
    onButtonClick(
      v1,
      id,
      v3,
      v4,
      v5,
      v6,
      v7,
      v8,
      v9,
      v10,
      v11,
      p1,
      p2,
      p3,
      p4,
      a1,
      a2,
      a3,
      a4,
      a5,
      a6,
      a7,
      a8,
      a9,
      a10,
      a11,
      a12,
      neededMenu
    );
  };

  const closeAudience = () => {
    // Handle the close event here
    setShowAudiencePopup(false);
  };

  const closeEditAudience = () => {
    setAudEditPopup(false);
  };

  // Inputs may need to be prefilled
  //   if (!personaMarketingIdeasInput) return null;

  return (
    <Formik
      initialValues={audienceChangerInput}
      onSubmit={async (values, actions) => {
        if (A1 === '') {
          setAudError(true);
          const target = document.querySelector('#aud') as HTMLElement;
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        await logRecentPersonaData({
          RecentAudience: A0,
          RecentAudienceProfilePic: picture2,
          RecentPainpoints: A1,
          RecentLocation: A2,
          RecentOccupation: A3,
          RecentAge: A4,
          RecentAudienceGoals: A5,
          RecentAudienceTriggers: A7,
          RecentAudienceBarriers: A6,
        });
        values.audience = A0;
        values.painpoint = A1;
        values.location = A2;
        values.occupation = A3;
        values.age = A4;
        values.goals = A5;
        values.barriers = A6;
        values.triggers = A7;
        await submitToolkitForm({
          values,
          actions,
          formType: FormType.AUDIENCE_CHANGER,
        });
      }}
      validationSchema={PersonaMarketingIdeasInputsSchema}
    >
      {(props) => (
        <>
          <div className={formStyles['form-container']}>
            <ListenToFormikValues
              callBackFunc={(values) => {
                setAudienceChangerInput(values as AudienceChangerInput);
                setCanKeepGoing(false);
              }}
            />

            <div>
              <div className={styles['create-button3']}>
                <div></div>
              </div>

              {showAudEditPopup && (
                <BasicPopup2 id="persona-popup">
                  <div className={styles['popup-container5']}>
                    <div className={styles['popup-header-container']}>
                      <h3>Audience Persona Creation</h3>
                      <button onClick={() => setAudEditPopup(false)}>
                        <Image
                          src="/icons/CloseBlack.svg"
                          alt="Close"
                          layout="fixed"
                          objectFit="contain"
                          height={24}
                          width={24}
                        />
                      </button>
                    </div>
                    <div className={styles['inner']}>
                      {
                        <EditAudiencePersonaPopup
                          brand={a2}
                          id={a8}
                          audience={a1}
                          age={a4}
                          occupation={a5}
                          location={a6}
                          painpoints={a7}
                          gender={a3}
                          goals={a9}
                          barriers={a10}
                          triggers={a11}
                          profilePic={a12}
                          onClose={closeEditAudience}
                        />
                      }
                    </div>
                  </div>
                </BasicPopup2>
              )}
              {showAudDeletePopup && (
                <BasicPopup2 id="persona-popup">
                  <div className={styles['popup-container']}>
                    <div className={styles['popup-header-container']}>
                      <button onClick={() => setAudDeletePopup(false)}>
                        <Image
                          src="/icons/CloseBlack.svg"
                          alt="Close"
                          layout="fixed"
                          objectFit="contain"
                          height={24}
                          width={24}
                        />
                      </button>
                    </div>
                    <div className={styles['center']}>
                      <div>
                        <div className={styles['DeleteText']}>
                          <b>Are you sure you want to delete this persona?</b>
                        </div>
                        <div className={styles['DeleteButtons']}>
                          <BasicButton
                            theme="dark"
                            type="button"
                            loading={loading}
                            disabled={false}
                            text="Cancel"
                            onClick={() => {
                              setAudDeletePopup(!showAudDeletePopup);
                            }}
                            extraStyles={{
                              scale: '100%',
                            }}
                          />{' '}
                          <span>&nbsp;</span> <span>&nbsp;</span>
                          <BasicButton
                            theme="red"
                            type="button"
                            loading={loading}
                            disabled={false}
                            text="Delete"
                            image={{
                              src: '/icons/DeleteWhite.svg',
                              height: 16,
                              width: 16,
                            }}
                            onClick={async () => {
                              const id = a8;
                              await deleteAudience({ id });
                              setAudDeletePopup(!showAudDeletePopup);
                            }}
                            extraStyles={{
                              scale: '100%',
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </BasicPopup2>
              )}

              {/* The Start of the DropDowns */}
            </div>
            <div>
              <div>
                <h2>What text do you want to change?</h2>
              </div>

              <BoxedAutoResizeTextarea
                id="textarea"
                placeholder="Please enter the text you want to change."
                value={props.values.text}
                setValue={props.handleChange('text')}
                disabled={loading}
                errors={props.errors.text as string}
                touched={props.touched.text ? true : false}
                onBlur={props.handleBlur}
              />
            </div>

            <div>
              <div className={styles['create-button']}>
                <div>
                  <h2 id="aud">Change Text to this Audience Persona</h2>
                </div>
                <div></div>
              </div>
              <div ref={menuRef2}>
                {showAudiencePopup && (
                  <BasicPopup2 id="persona-popup">
                    <div className={styles['popup-container5']}>
                      <div className={styles['popup-header-container']}>
                        <h3>Audience Persona Creation</h3>
                        <button onClick={() => setShowAudiencePopup(false)}>
                          <Image
                            src="/icons/CloseBlack.svg"
                            alt="Close"
                            layout="fixed"
                            objectFit="contain"
                            height={24}
                            width={24}
                          />
                        </button>
                      </div>
                      <div className={styles['inner']}>
                        {<AudiencePersonaSoloPopup onClose={closeAudience} />}
                      </div>
                    </div>
                  </BasicPopup2>
                )}
                <DropDownContainer3>
                  <DropDownHeader onClick={toggling2}>
                    <div>
                      <Image
                        src={picture2 ? picture2 : '/icons/nobrand.svg'}
                        alt="Close"
                        layout="fixed"
                        objectFit="contain"
                        height={24}
                        width={24}
                        className={styles['image2']}
                      />
                    </div>{' '}
                    <span>&nbsp;</span>
                    <Innertext>
                      {selectedAudOption
                        ? selectedAudOption
                        : 'Choose an Audience'}
                    </Innertext>
                    <DropDownIcon3>
                      <Image
                        src={'/icons/Arrow Chevron Down.svg'}
                        alt="Close"
                        layout="fixed"
                        objectFit="contain"
                        height={24}
                        width={24}
                      />
                    </DropDownIcon3>
                  </DropDownHeader>
                  {isOpen2 && (
                    <DropDownListContainer>
                      <DropDownList>
                        <ListItem2
                          key={'create'}
                          onClick={() => AudienceCreateClick()}
                        >
                          <Image
                            src={'/icons/Actions Plus.svg'}
                            alt=""
                            objectFit="contain"
                            layout="fixed"
                            width={24}
                            height={24}
                          />{' '}
                          <span>&nbsp;</span>
                          <div className={styles['left-space']}>
                            Create an Audience Persona
                          </div>
                        </ListItem2>
                        {audiencePersonas?.map((company) => (
                          <ListItem key={company.id} value={selectedAudience}>
                            <div
                              className={styles['pic-image']}
                              onClick={onAudOptionClicked(
                                company.audience,
                                company.painpoints,
                                company.location,
                                company.occupation,
                                company.age,
                                company.goals ?? '',
                                company.barriers ?? '',
                                company.triggers ?? '',
                                company.profilePic ?? '',
                                company,
                              )}
                            >
                              <Image
                                src={
                                  company.profilePic
                                    ? company.profilePic
                                    : '/icons/nobrand.svg'
                                }
                                alt="Close"
                                layout="fixed"
                                objectFit="contain"
                                height={24}
                                width={24}
                                className={styles['image2']}
                              />{' '}
                              <span>&nbsp;</span>
                              <div className={styles['left-space']}>
                                {company.audience}
                              </div>
                            </div>
                            {((userData?.organizationOwner &&
                              company.organizationPersona) ||
                              !company.organizationPersona) &&
                              userData?.position !== 'Content Creator' && (
                                <div className={styles['BrandEdit']}>
                                  <div
                                    className={styles['edit-button']}
                                    onClick={AudienceEditClick(
                                      company.audience,
                                      company.brand,
                                      company.gender,
                                      company.age,
                                      company.occupation,
                                      company.location,
                                      company.painpoints,
                                      company.id,
                                      company.goals ?? '',
                                      company.barriers ?? '',
                                      company.triggers ?? '',
                                      company.profilePic ?? ''
                                    )}
                                  >
                                    <Image
                                      src={'/icons/Edit_Icon.svg'}
                                      alt="Close"
                                      layout="fixed"
                                      objectFit="contain"
                                      height={14}
                                      width={14}
                                      className={styles['image']}
                                    />
                                  </div>{' '}
                                  <span>&nbsp;</span>
                                  <div
                                    className={styles['delete-button']}
                                    onClick={AudienceDeleteClick(
                                      company.audience,
                                      company.brand,
                                      company.gender,
                                      company.age,
                                      company.occupation,
                                      company.location,
                                      company.painpoints,
                                      company.id,
                                      company.goals ?? '',
                                      company.barriers ?? '',
                                      company.triggers ?? '',
                                      company.profilePic ?? ''
                                    )}
                                  >
                                    <Image
                                      src={'/icons/Delete.svg'}
                                      alt="Close"
                                      layout="fixed"
                                      objectFit="contain"
                                      height={14}
                                      width={14}
                                      className={styles['image']}
                                    />
                                  </div>
                                </div>
                              )}
                          </ListItem>
                        ))}
                      </DropDownList>
                    </DropDownListContainer>
                  )}
                </DropDownContainer3>
                {audError && (
                  <p>
                    <span style={{ color: '#FF0000' }}>
                      Please Select an Audience
                    </span>
                  </p>
                )}
              </div>
            </div>
          </div>

          <GenerateResponseButtons
            onSubmit={() => {
              props.handleSubmit();
            }}
          />
        </>
      )}
    </Formik>
  );
};
